import React, { useState, useEffect } from 'react'; // Added useEffect
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import AboutUs from '../AboutUs/AboutUs';
import FAQSection from './FAQSection/FAQSection';
import TeamGrid from '../Team/TeamGrid';
import TeamJoinForm from '../Team/TeamJoinForm';
import ContactStack from '../ContactPage/ContactPage';
import whatsappImg from "../../assets/whatsapp.png";
import ScrollToTop from '../ScrollToTop/ScrollToTop';


const FullAbout = () => {
  // 1. Declare state INSIDE the function
  const [showContact, setShowContact] = useState(false);

    // FORCE SCROLL TO TOP ON LOAD
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <>
    <div className="about-page-wrapper" id="about">
      <ScrollToTop/>
      <Navbar />
      <div>
        <AboutUs/>
      </div>

      
      {/* <BrandPurposeSection/> */}
    {/*   <CraftingBrands/> */}
      <FAQSection/>
      <TeamGrid />
      <TeamJoinForm />
      {/* 2. Pass the trigger to Footer */}
      <Footer onContactClick={() => setShowContact(true)} />

      {/* 3. Render the Stack here */}
      {showContact && (
        <ContactStack onClose={() => setShowContact(false)} />
      )}
       {/* Fixed WhatsApp Icon */}
                  <a
                    href="https://wa.me/7540001028"
                    className="whatsapp-float"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      position: "fixed",
                      bottom: "30px",
                      right: "20px",
                      zIndex: 9999,
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src={whatsappImg}
                      alt="WhatsApp Chat"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "50%",
                      }}
                    />
                  </a>
    </div>
    </>
  );
};

export default FullAbout;